/* -------------------------------------------------------------------------- */
/*                                PK-BOX styles                               */
/* -------------------------------------------------------------------------- */

@import './pk-box.variables';

:host {
  @apply box-border block h-full;
}

.pk-box {
  @apply box-border block h-full w-full rounded-[--box--border-radius] bg-[color:--box--background-color] bg-clip-border;
  @apply pb-[--box--padding-bottom-mobile] pl-[--box--padding-left-mobile] pr-[--box--padding-right-mobile] pt-[--box--padding-top-mobile];
  @apply md:pb-[--box--padding-bottom-desktop] md:pl-[--box--padding-left-desktop] md:pr-[--box--padding-right-desktop] md:pt-[--box--padding-top-desktop];
}

.has-shadow {
  box-shadow: var(--box--shadow);
}

.has-stroke {
  @apply border-[length:--box--border-width] border-solid border-[color:--box--border-color];
}

.no-padding {
  @apply p-0;
}
